var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav-item nav-dropdown nav-dropdown-parent",
    attrs: {
      "tag": "li",
      "to": _vm.url,
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.name))]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3677cc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarNavDropdown.vue
// module id = 351
// module chunks = 1